import { ParentOrientationVideoModel } from './parentOrientationVideoModel';

export class ParentOrientationPlaylist {
  videos: ParentOrientationVideoModel[] = [];
  selectedVideo: ParentOrientationVideoModel | null = null;

  setVideos(videos: ParentOrientationVideoModel[] | null): void {
    this.videos = videos || [];
    this.selectedVideo = this.videos.length > 0 ? this.videos[0] : null;
  }

  select(video: ParentOrientationVideoModel): void {
    if (this.videos.some(item => item.id === video.id)) {
      this.selectedVideo = video;
    }
  }

  selectNext(): void {
    if (!this.selectedVideo || this.videos.length < 2) {
      return;
    }

    const currentIndex = this.videos.findIndex(video => video.id === this.selectedVideo.id);
    if (currentIndex >= 0 && currentIndex + 1 < this.videos.length) {
      this.selectedVideo = this.videos[currentIndex + 1];
    }
  }

  replace(refreshedVideo: ParentOrientationVideoModel): void {
    const currentIndex = this.videos.findIndex(video => video.id === refreshedVideo.id);
    if (currentIndex < 0) {
      return;
    }

    this.videos[currentIndex] = refreshedVideo;
    if (this.selectedVideo?.id === refreshedVideo.id) {
      this.selectedVideo = refreshedVideo;
    }
  }

  needsPlaybackRefresh(video: ParentOrientationVideoModel | null, now: Date = new Date()): boolean {
    if (!video?.isUploaded || !video.playbackURLExpiresUtc) {
      return false;
    }

    const expiresAt = new Date(video.playbackURLExpiresUtc).getTime();
    return !Number.isFinite(expiresAt) || expiresAt <= now.getTime() + 5 * 60 * 1000;
  }
}
